import withMetadataArgument from './withMetadataArgument.js'
import { getCountries as _getCountries } from '../../core/index.js'

export function getCountries() {
	return withMetadataArgument(_getCountries, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/getCountries.js
// module id = 1154
// module chunks = 22